import React from 'react';

export const LoadingLogo: React.FC = () => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="flex items-center justify-center">
        <img
          src="/Musicade-Logo.png"
          alt="Musicade logo"
          className="w-24 h-24 object-contain animate-[breathe_2.4s_ease-in-out_infinite]"
        />
      </div>

      <style>{`
        @keyframes breathe {
          0%, 100% {
            transform: scale(0.92);
            opacity: 0.6;
          }
          50% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};
